var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"view"}},[_c('van-dialog',{attrs:{"showConfirmButton":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"dots"},[_c('div'),_c('div'),_c('div')])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }